import React from 'react';
import { VCredit, VIcon } from './VCredit';

export const WalletBalanceRow = ({ minor, label, prefix, balanceTestId }) => <div className="wallet-currency-balance" data-testid={`${prefix}-summary`}>
  <div className="wallet-currency-identity"><span className="wallet-currency-emblem" aria-hidden="true"><VIcon testid={`${prefix}-currency-icon`} /></span><span><strong data-testid={`${prefix}-currency-name`}>V credits</strong><small data-testid={`${prefix}-label`}>{label}</small></span></div>
  <VCredit minor={minor} testid={balanceTestId} />
</div>;